import { call, put } from 'redux-saga/effects';
import jwt from 'jsonwebtoken';
import { getErrorMessage } from '../../services/Errors';
import LoginActions from '../actions/LoginActions';
import ConfigActions from '../actions/ConfigActions';
import { storeSessionInfo, clearSessionInfo } from '../../services/JwtStore';

const { loginSuccess, loginFailure, logoutSuccess } = LoginActions;

const { getConfigRequest } = ConfigActions;

export function* login(api, { email, password, history }) {
  const response = yield call(api.login, email, password);
  if (response.ok) {
    yield call(storeSessionInfo, response.data);
    yield call(api.setToken, response.data.access_token);
    if (response.data.access_token) {
      let decoded = jwt.decode(response.data.access_token);
      if (decoded) {
        response.data.authorities = decoded.authorities;
      }
    }
    yield put(loginSuccess(response.data));
    yield call(history.replace, '/applications');
    yield put(getConfigRequest());
  } else {
    yield put(loginFailure(getErrorMessage(response, 'unableToLogin')));
  }
}

export function* logout(api) {
  yield call(api.logout);
  clearSessionInfo();
  yield put(logoutSuccess());
}



// WEBPACK FOOTER //
// ./src/state/sagas/LoginSagas.js